import ResourceTrigger from '@triggers/ResourceTrigger'

class AddMemberNoteTrigger extends ResourceTrigger

  @triggerConfig: ->
    computed:
      defaultTriggerName: -> 'add_member_note'

    methods:
      modalData: -> { note: null }

export default AddMemberNoteTrigger